export class UpdateLocationContactInput {
  id: number;
  emailAddress?: string | null;
  storeContactInfo?: string | null;
  storeOpeningHours?: string | null;
}
